export default {
  getPayrollSheetItem: (state) => state.payrollSheetItem,
};
